import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import Token from '../common/Token.jsx';

function EditionSetsComponent(props) {
    const data = props.data || {};
    const inventory = data.inventory || {};

    let rowSpacing;
    let style = {};
    if (props.blockConfig && props.blockConfig.block) {
        Block.mapStyleConfigProps(style, props.blockConfig.block, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'design':
                    return true;
                case 'rowSpacing':
                    if (propValue && propUnit) {
                        rowSpacing = `${propValue}${propUnit}`;
                    }
                    return true;
            }
        });
    }
    let content;
    if (inventory.editionSets) {
        content = inventory.editionSets.map((d, i) =>
            <EditionSetCell
                key={i}
                blockConfig={props.blockConfig}
                data={d}
                isLast={i == inventory.editionSets.length - 1}
                rowSpacing={rowSpacing} />
        )
    }
    if (!props.builder && (content == undefined || content.length == 0)) {
        return null;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    let className = 'cont--edition__sets';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let renderedContent = (
        <div className={className} style={layoutStyles.style}>
            {content}
            {
                props.builder &&
                (content == undefined || content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        renderedContent = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{renderedContent}</div>
    }
    return renderedContent;
}

function _EditionSetCell(props) {
    if (props.content != undefined && props.content.length == 0) {
        return null;
    }
    const style = { lineHeight: 1 };
    if (!props.isLast && props.rowSpacing) {
        style.marginBottom = props.rowSpacing
    }
    return <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={style} />
}
const EditionSetCell = Token.withContentTokenParsing(_EditionSetCell, {}, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.AlternateDimensions:
            if (data.alternateDimensions && data.alternateDimensions.length > 0) {
                replaceString = Token.getReplacementString(data.alternateDimensions, options);
            }
            break;
        case Token.Dimensions:
            if (data.dimensions && data.dimensions.length > 0) {
                replaceString = Token.getReplacementString(data.dimensions, options);
            }
            break;
        case Token.EditionCount:
            if (data.editionCount && data.editionCount.length > 0) {
                replaceString = Token.getReplacementString(data.editionCount, options);
            }
            break;
        case Token.Medium:
            if (data.medium && data.medium.length > 0) {
                replaceString = Token.getReplacementString(data.medium, options);
            }
            break;
    }
    return replaceString;
});

const EditionSetTokens = () => {
    return [
        Token.getWrappedTokenConfig('Edition Count', Token.EditionCount),
        Token.getWrappedTokenConfig('Dimensions', Token.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.AlternateDimensions),
        Token.getWrappedTokenConfig('Medium', Token.Medium)
    ];
}
export default { Component: EditionSetsComponent, Tokens: EditionSetTokens };